import Typed from 'typed.js';
import { TypeAnimation } from 'react-type-animation';
import myphoto from '../Components/assets/myphoto.png'
import { Link as NavLinkes} from 'react-scroll';
import { Box, Button, Text,Image, background,   useColorMode,useColorModeValue } from '@chakra-ui/react';
const TopSection =()=>{
  const { colorMode, toggleColorMode } = useColorMode();

  const handleresume=()=>{
    window.open('https://drive.google.com/file/d/1w9zO6biz20SPgIQ2KU7j8U16AfaQKnNk/view?usp=share_link',"_blank")
  }


  return (
 <Box className="wrapper"  mt={{base:"65px",sm:"75px",md:"60px",xl:"2px"}} height={{base:"auto",sm:"850px",xl:"850px","2xl":"850px"}}>
    <div className="cols cols0">
<Text mt={{base:"50px"}} className="topline">Hii there!👋</Text>
<Box className='words' width={"auto"} display={{base:"none",sm:"block",xl:"block","2xl":"block"}} >

<h3 className="iam">I am Uzair a<span className="multitext" style={{backgroundColor:"black"}}>
  <br />
  

<TypeAnimation
sequence={[
  'Coder', // Types 'One'
  1000, // Waits 1s
  'Software Engineer', // Deletes 'One' and types 'Two'
  2000, // Waits 2s
  'Web Developer',
  1000 // Types 'Three' without deleting 'Two'
  //   () => {
    //     console.log('Done typing!'); // Place optional callbacks anywhere in the array
    //   }
  ]}
  wrapper="span"

  cursor={true}
  repeat={Infinity}
  style={{ fontSize: '0.8em' }}
/></span></h3>
  </Box>
  <Box>
<Text  fontSize={"35px"} color={'yellow'} fontWeight={'900'} display={{base:"block",sm:"none",xl:"none","2xl":"none"}}>
I am Uzair 

</Text>

  </Box>
<Text style={{color:"white",fontSize:"25px",lineHeight:"40px"}}>A Passionate Full Stack Web Developer</Text>
 <Box as={"flex"} gap={"20px"}>
    <button id="resume-button-2">
  
      <a href="Uzair_Resume.pdf" download="Uzair_Resume.pdf"  onClick={handleresume} id="resume-link-2">
      <Button id="hover" mt={"30px"} mr={"30px"} bgColor={"white"} color={"black"}><Text>Resume</Text>
             
             <img width={"25px"} height={"20px"} src="https://cdn.iconscout.com/icon/premium/png-512-thumb/download-1889464-1597509.png?f=avif&w=256" alt="" />
                </Button>
</a>
    </button>
{/* <img width={"25px"} height={"20px"} src="https://cdn.iconscout.com/icon/premium/png-512-thumb/download-1889464-1597509.png?f=avif&w=256" alt="" /> */}
<NavLinkes  to="projects"
              className="nav-link projects"
                activeClass="active" smooth spy>

<Button id="myproj" style={{marginRight:"30px",backgroundColor:"white",marginTop:"30px",color:"black",border:"1px solid black"}}>My Projects</Button>
                </NavLinkes>
   </Box>
   
    </div>

<div className="cols cols1"></div>
</Box>
)}
  
export default TopSection